module.exports = {
  /* This style only works with bootstrap css framework */
  buttonStyles: {
    success: "btn-success",
    default: "btn-default",
  },
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Signature/assets/js/constants.js